import { Dayjs } from 'dayjs'

export const dateIsBetween = (date: Dayjs, lowBoundary: Dayjs, highBoundary: Dayjs) => {
  return (
    date.isSame(lowBoundary, 'day') ||
    date.isSame(highBoundary, 'day') ||
    (date.isAfter(lowBoundary, 'day') && date.isBefore(highBoundary, 'day'))
  )
}
